import { Component } from '@angular/core';

@Component({
  templateUrl: './download-reports.page.html',
})
/**
 * Downolad Reports Page (_8^())
 */
export class DownloadReportsPage {}
